import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=ed5534e0&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=ed5534e0&prod&lang=scss&"
import style1 from "./order-list.vue?vue&type=style&index=1&id=ed5534e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5534e0",
  null
  
)

export default component.exports